import React from 'react'
import { parse } from '@wordpress/block-serialization-default-parser'

import { GetTheBlock } from './Blocks'

const Block = ({ block, mapToBlock }) => {
  const { blockName, attrs, innerBlocks, innerHTML, innerContent } = block
  if (!blockName) return null

  if (mapToBlock) Block.mapToBlock = mapToBlock

  let TheBlock = Block.mapToBlock ? Block.mapToBlock(blockName) : null
  if (!TheBlock) TheBlock = GetTheBlock(blockName)

  if (!TheBlock) return null

  return (
    <TheBlock
      blockName={blockName}
      attrs={attrs}
      innerBlocks={innerBlocks}
      innerHTML={innerHTML}
      innerContent={innerContent}
    />
  )
}

const Blocks = ({ raw, mapToBlock }) => {
  if (!raw) return null
  const content = parse(raw)

  return (
    <div className="wp-blocks">
      {content
        .filter(block => !!block.blockName)
        .map((block, index) => (
          <Block key={index} block={block} mapToBlock={mapToBlock} />
        ))}
    </div>
  )
}

const Head = ({ title, excerpt }) => {
  return (
    <>
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      <div className="excerpt" dangerouslySetInnerHTML={{ __html: excerpt }} />
    </>
  )
}

export { Blocks, Head }
